import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=2f31f88e&scoped=true&"
import script from "./AccountLayout.vue?vue&type=script&lang=js&"
export * from "./AccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AccountLayout.vue?vue&type=style&index=1&id=2f31f88e&scoped=true&lang=css&"
import style2 from "./AccountLayout.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31f88e",
  null
  
)

export default component.exports